import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getTablesAndReservationPerRegionRequest = async (
  token,
  { getReservationsData }
) => {
  const url =
    apiURl +
    "reservation/tables?&regionId=" +
    getReservationsData.regionId +
    "&organizationId=" +
    getReservationsData.organizationId +
    "&ReservationDate=" +
    getReservationsData.date;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getReservationsPerRegionRequest = async (
  token,
  { getReservationsData }
) => {
  const regionIdParam = getReservationsData.regionId ?? "";
  const url =
    apiURl +
    "reservation/GetAll?organizationId=" +
    getReservationsData.organizationId +
    "&regionId=" +
    regionIdParam +
    "&ReservationDate=" +
    getReservationsData.date;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const createReservationGetTablesRequest = async (
  token,
  { reservationTablesData }
) => {
  const url =
    apiURl +
    "Reservation/Table/AvailableByDateTime?organizationId=" +
    reservationTablesData.organizationId +
    "&regionId=" +
    reservationTablesData.regionId +
    "&ReservationDate=" +
    reservationTablesData.date +
    "&reservationTime=" +
    reservationTablesData.time;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const createReservationRequest = async (token, { createReservationData }) => {
  // Remove date because this is selected date that I use to remove or add reservation from List component for specific date
  delete createReservationData.date;

  const url = apiURl + "reservation/create";
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(createReservationData),
  };

  return fetchAndReturn(url, parameters);
};

const editReservationRequest = async (token, { editReservationData }) => {
  // Remove date because this is selected date that I use to remove or add reservation from List component for specific date
  delete editReservationData.date;

  const url = apiURl + "reservation/edit";
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(editReservationData),
  };

  return fetchAndReturn(url, parameters);
};

const deleteReservationRequest = async (token, { reservationId }) => {
  const url =
    apiURl +
    "reservation/delete?organizationId=" +
    localStorage.getItem("organizationId") +
    "&reservationId=" +
    reservationId;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  return fetchAndReturn(url, parameters);
};

const createReservationClientHistoryRequest = async (
  token,
  { createReservationClientHistoryData }
) => {
  const url =
    apiURl +
    "Reservation/GetReservationGuestInfo?phone=" +
    createReservationClientHistoryData.phone +
    "&organizationId=" +
    createReservationClientHistoryData.organizationId;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  return fetchAndReturn(url, parameters);
};

export {
  getTablesAndReservationPerRegionRequest,
  getReservationsPerRegionRequest,
  createReservationGetTablesRequest,
  createReservationRequest,
  editReservationRequest,
  deleteReservationRequest,
  createReservationClientHistoryRequest,
};
